// Reporting Page Slice
import { reportingPageInitialState } from "./uiLandingPageReportingPageState";
import { makeReportingPageActions } from "./uiLandingPageReportingPageActions";

export const createReportingPageSlice = (set, get) => ({
  reportingPage: reportingPageInitialState,
  reportingPageActions: makeReportingPageActions(set, get),
});
